import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'legfiPhone',
    standalone: true,
})
export class LegfiPhonePipe implements PipeTransform
{
    public transform(value: string) {
        if (typeof value === 'undefined' || value === null) {
            return '';
        }
        if (value.length === 11 && value[0] === '1') {
            return '+1-' + value.substring(1, 4) + '-' + value.substring(4, 7) + '-' + value.substring(7);
        } else if (value.length === 10) {
            return value.substring(0, 3) + '-' + value.substring(3, 6) + '-' + value.substring(6);
        } else if (value.length === 7) {
            return value.substring(0, 3) + '-' + value.substring(3);
        }

        return value;
    }
}
